
export default {
  async asyncData({ $getContent }) {
    return {
      people: await $getContent('about'),
    }
  },
  head: {
    title: 'About Us',
  },
}
